import React from 'react';
import { Grid, Paper, Button } from '@mui/material';
import './ExpertRecommendMessage.css';
import RefreshIcon from '@mui/icons-material/Refresh';

const ExpertRecommendMessage = ({ content, onExpertSelect, websocket }) => {
  const formatTime = (timeStr) => {
    if (!timeStr) return "从未";
    try {
      const date = new Date(timeStr);
      return date.toLocaleTimeString('zh-CN', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: false 
      });
    } catch (e) {
      return timeStr;
    }
  };

  const handleExpertClick = (expert) => {
    onExpertSelect(`@${expert.command}`);
  };

  const handleRefresh = () => {
    // 通过 WebSocket 发送换一批请求
    const message = {
      type: "refresh_experts",
    };

    console.log("发送换一批请求:", message); // 打印发送的数据

    if (websocket && websocket.readyState === WebSocket.OPEN) {
      websocket.send(JSON.stringify(message));
    } else {
      console.error("WebSocket 未连接或状态异常");
    }
  };

  return (
    <div className="expert-recommend-message">
      <div className="recommend-header">
        <span>推荐专家</span>
        <Button 
          className="refresh-btn"
          onClick={handleRefresh}
          startIcon={<RefreshIcon />}
        >
          换一批
        </Button>
      </div>
      <Grid container spacing={2} className="experts-grid">
        {content.map((expert, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper 
              className="expert-card"
              onClick={() => handleExpertClick(expert)}
            >
              <div className="expert-name">{expert.name}</div>
              <div className="expert-description">{expert.description}</div>
              <div className="expert-reason">{expert.reason}</div>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ExpertRecommendMessage; 